import L from 'leaflet'

import {
  TrackPlayBack,
  trackplayback
} from './trackplayback'

L.TrackPlayBack = TrackPlayBack
L.trackplayback = trackplayback
